
export function Logout() {
    localStorage.clear();
    window.location.href = this.$MyCrypto(window.VUE_APP_KEYCLOAK_URL, 1) +
      "realms/" + this.$MyCrypto(window.VUE_APP_KEYCLOAK_REALM, 1) +
      "/protocol/openid-connect/logout";


}